// extracted by mini-css-extract-plugin
export default {"Dialog":"style_Dialog__lkPiE","Content":"style_Content__G7Tl5"};